import { SidebarComponent, LoaderComponent, HeaderComponent } from "../ui";
import { NARROW_QUERY } from "../ui/sidebar";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import TopMarquee from "../ui/TopMarquee";
import { PageTitleProvider } from "./PageTitleContext";
import { ChatProvider } from "../chat/ChatProvider";
import ChatDock from "../chat/ChatDock";
import { TourProvider } from "../../tours/TourProvider";
import { NoticeProvider } from "../notices/NoticeProvider";
import { useIsMobile } from "../chat/useMedia";
import PullToRefresh from "../ui/PullToRefresh";
import OfflineBanner from "../ui/OfflineBanner";


function Layout({ isProtectedView, children, isLoading = false }) {
  //eslint-disable-next-line no-unused-vars
  const location = useLocation();
  // Phones: no sidebar; the header turns into an app bar with a top-level menu (see ui/MobileNav.jsx).
  const mobile = useIsMobile();
  const showSidebar = isProtectedView && !mobile;
  // Start collapsed on narrow screens so mobile loads don't animate closed.
  const [collapsed, setCollapsed] = useState(
    () => typeof window !== "undefined" && window.matchMedia(NARROW_QUERY).matches,
  );

  const content = (
    <PageTitleProvider>
      <div
        className="bg-app-secondary text-app-primary flex max-w-screen min-h-screen overflow-visible relative"
        style={{ overscrollBehaviorX: "contain", scrollbarGutter: "stable" }}
      >
        {isLoading && <LoaderComponent />}

        <div
          // No transition here: animating margin/width reflowed the whole page (and
          // the records table) every frame. The fixed sidebar animates over it instead.
          className={`flex flex-col flex-1 ${
            showSidebar
              ? collapsed
                ? "ml-[80px] w-[calc(100%-80px)]"
                : "ml-[300px] w-[calc(100%-300px)]"
              : "ml-0 w-full"
          }`}
        >
          <main className="min-h-screen relative z-[1] bg-app-primary">
            {showSidebar && (
              <SidebarComponent
                collapsed={collapsed}
                setCollapsed={setCollapsed}
              />
            )}

            {isProtectedView && <HeaderComponent />}
     

            {children}
          </main>
        </div>
      </div>
    </PageTitleProvider>
  );

  // Chat lives for the whole logged-in session, so it wraps every protected page.
  if (!isProtectedView) return content;
  return (
    <ChatProvider>
      <TourProvider>
        <NoticeProvider>
          {content}
          <ChatDock />
          {mobile && <PullToRefresh />}
          <OfflineBanner />
        </NoticeProvider>
      </TourProvider>
    </ChatProvider>
  );
}

export default Layout;
